export const getContractData = (contractdata) => ({
  type: "ContractData",
  payload: contractdata,
});
